import type { SignupOnboardingState } from "@/lib/onboarding/signup-onboarding"

type SignupOnboardingStatus = SignupOnboardingState["status"]

type TenantOnboardingSummary = {
  status: SignupOnboardingStatus
}

export function filterTenantsBySignupOnboardingStatus<
  Tenant extends { id: string },
>(
  tenants: Tenant[],
  onboardingByTenant: ReadonlyMap<string, TenantOnboardingSummary>,
  selectedStatuses: readonly string[],
): Tenant[] {
  if (selectedStatuses.length === 0) return tenants

  const selected = new Set(selectedStatuses)
  return tenants.filter((tenant) =>
    selected.has(getEffectiveSignupOnboardingStatus(onboardingByTenant.get(tenant.id))),
  )
}

export function getEffectiveSignupOnboardingStatus(
  summary: TenantOnboardingSummary | undefined,
): SignupOnboardingStatus {
  return summary?.status ?? "completed"
}
